import "core-js/modules/es.object.keys.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Callbacks = /*#__PURE__*/function () {
  function Callbacks() {
    _classCallCheck(this, Callbacks);

    _defineProperty(this, "callbacks", {});

    _defineProperty(this, "id", 0);
  }

  _createClass(Callbacks, [{
    key: "register",
    value: function register(fn) {
      var _this = this;

      var once = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.id += 1;
      var id = this.id;
      this.callbacks[id] = {
        fn: fn,
        once: once
      };
      return function () {
        delete _this.callbacks[id];
      };
    }
  }, {
    key: "invoke",
    value: function invoke() {
      for (var id in this.callbacks) {
        var cb = this.callbacks[id];

        try {
          cb.fn();
        } finally {
          if (cb.once) delete this.callbacks[id];
        }
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      this.callbacks = {};
    }
  }, {
    key: "count",
    value: function count() {
      return Object.keys(this.callbacks).length;
    }
  }]);

  return Callbacks;
}();

export { Callbacks };